import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTagRegularDiagonalReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.9 22.3q1 .1 1.1 1v3.8q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8q.1-1 1.1-1.1zm4.5-4.6q1 .2 1.1 1.2V27q-.1 1-1.1 1.1h-.8q-.9 0-1-.8l-.1-.3V19q.1-1 1.1-1.1zm4.6 1.6h.4v.1a1 1 0 0 1 .6 1V27q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q.1-1 1.1-1.1h.8M15.4 4Q17 4 18 5l10.4 10.5q1 .9 1 2.1-.8-.3-1.5-.4h-1.2L16.3 6.8q-.5-.4-.9-.4H7.6q-1.1 0-1.2 1.2v7.8q0 .5.4.9l8.2 8.2V27l.1 1L5.1 18q-1-1-1-2.6V7.6C4 5.6 5.5 4 7.5 4zm-5 4.8a1.6 1.6 0 1 1 0 3.2 1.6 1.6 0 0 1 0-3.2" })
});
export default SvgTagRegularDiagonalReportIcon;
